import { render, staticRenderFns } from "./admin-issues.vue?vue&type=template&id=400c90eb"
import script from "./admin-issues.vue?vue&type=script&lang=js"
export * from "./admin-issues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports